/**
 * Los avisos nativos del navegador ("Please fill out this field.") salen en el
 * idioma del NAVEGADOR, no en el del helpdesk: con Chrome en inglés, todo campo
 * `required` vacío avisaba en inglés aunque la pantalla estuviera en español
 * (Thiago, 14-oct-2026, al crear un ticket vacío). Un solo listener global
 * reemplaza los dos avisos más comunes —campo vacío y email mal escrito— por el
 * texto traducido; el resto de las validaciones nativas quedan como estaban.
 */
import i18n from '../i18n';

let instalado = false;

export function installFormValidityI18n() {
  if (instalado || typeof document === 'undefined') return;
  instalado = true;

  document.addEventListener('invalid', (e) => {
    try {
      const el = e.target;
      if (!el || typeof el.setCustomValidity !== 'function' || !el.validity) return;
      if (el.validity.valueMissing) el.setCustomValidity(i18n.t('common.fieldRequired'));
      else if (el.validity.typeMismatch && el.type === 'email') el.setCustomValidity(i18n.t('common.invalidEmailField'));
    } catch { /* un aviso nunca puede romper el formulario */ }
  }, true);

  // Apenas el usuario corrige el campo, el aviso propio se borra: si no, el
  // campo seguiría "inválido" para siempre aunque ya tenga un valor.
  const limpiar = (e) => {
    try {
      const el = e.target;
      if (el && typeof el.setCustomValidity === 'function' && el.validationMessage) el.setCustomValidity('');
    } catch { /* nada */ }
  };
  document.addEventListener('input', limpiar, true);
  document.addEventListener('change', limpiar, true);
}
